import { Grid2, InputLabel, Typography, styled } from '@mui/material';

export const Container = ({ children, ...props }) => {
    return (
        <Grid2 container width="100%" direction="column" justifyContent="flex-start" alignItems="flex-start" gap="4px" {...props}>
            {children}
        </Grid2>
    );
};

export const Label = styled(InputLabel)({
    fontSize: '18px',
    fontWeight: 400,
    color: '#131313',
});

export const Title = ({ title, description, align = 'flex-start' }) => {
    return (
        <Grid2 container direction="column" justifyContent="flex-start" alignItems={align} gap="8px" mb="16px">
            <Typography variant="h4" component="h1" fontSize={20} fontWeight={900} sx={{ color: '#131313' }} noWrap>
                {title}
            </Typography>
            <Typography fontSize={16} fontWeight={500} sx={{ color: '#131313bf' }}>
                {description}
            </Typography>
        </Grid2>
    );
};

export const PRICE_TYPE = {
    FIXED: '1',
    PRICE_GROUP: '2',
};
